import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import { RatingsActionTypes, UsersActionTypes } from '../../actions/types';

const fetchRatingsByUserId = makeAsyncReducerHandlers(
  RatingsActionTypes.fetchRatingsByUserId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.ratings,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addOrUpdateRating = makeAsyncReducerHandlers(
  RatingsActionTypes.addOrUpdateRating,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { rating } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === rating._id);

    if (index === -1) {
      items.push(rating);
    } else {
      items.splice(index, 1, rating);
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getUserWithMiscData = makeAsyncReducerHandlers(
  UsersActionTypes.getUserWithMiscData,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.shouldLoadMoreProjects ? state.items : action.payload.ratings,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const changeRatingStatus = makeAsyncReducerHandlers(
  RatingsActionTypes.changeRatingStatus,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { _id, isActive } = action.payload.rating;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === _id);
    const currentRating = items[index];

    if (index === -1) {
      items.push({ ...currentRating, isActive });
    } else {
      items.splice(index, 1, { ...currentRating, isActive });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deleteRating = makeAsyncReducerHandlers(
  RatingsActionTypes.deleteRating,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: Array.from(state.items).filter(r => r._id !== action.payload.ratingId),
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getProjectsFeedbackData = makeAsyncReducerHandlers(
  RatingsActionTypes.getProjectsFeedbackData,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.ratings,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getProjectsFeedbackForExcel = makeAsyncReducerHandlers(
  RatingsActionTypes.getProjectsFeedbackForExcel,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);


export default {
  fetchRatingsByUserId,
  addOrUpdateRating,
  getUserWithMiscData,
  changeRatingStatus,
  deleteRating,
  getProjectsFeedbackData,
  getProjectsFeedbackForExcel,
};
